import { addAction, removeAction, addController, removeController, hasController, closestTo, importJson, importJsonFromScript } from "./dom";
import { setControllerClass, setControllerClasses, onControllerInit, addControllerAction, addControllerActionWithCleanup, onControllerDisconnect, applyClasses, applyContextController, applyContext } from "./controller";
import { createPopper } from "./create-popper";

export default {
    // Stimulus JS helper functions
    addAction,
    addControllerAction,
    addControllerActionWithCleanup,
    removeAction,
    addController,
    removeController,
    hasController,
    applyContext,
    applyClasses,
    applyContextController,
    setControllerClass,
    setControllerClasses,
    onControllerInit,
    onControllerDisconnect,
    // floating-ui helper functions
    createPopper,
    // general dom-related helper functions
    closestTo,
    importJson,
    importJsonFromScript,
}

// Commented because it produces a separate file in the bundled output
// export * from "./view";
export * from "./controller-tag";
export * from "./proxy-controller";
export { InjectableContext, ContextData } from "./controller";
export { PopperPlacement } from "./create-popper";
export * from "./vanilla";